import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import SyncStatusChip from './SyncStatusChip';

const MobileHeader = ({
  title,
  showBack = false,
  onBack,
  rightAction,
  transparent = false,
  showSync = true,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <header className={`sticky top-0 z-40 px-4 py-3 flex items-center justify-between ${
      transparent ? 'bg-transparent' : 'bg-[var(--surface-card)] border-b border-[var(--border)]'
    }`}>
      <div className="flex items-center gap-3 min-w-0">
        {showBack && (
          <button
            onClick={handleBack}
            className="p-1 -ml-1 rounded-lg hover:bg-[var(--surface-pressed)] active:bg-[var(--surface-pressed)] transition-colors"
            aria-label="Back"
          >
            <ChevronLeft className="w-6 h-6 text-[var(--ink-primary)]" />
          </button>
        )}
        <h1 className="text-lg font-semibold text-[var(--ink-primary)] truncate">{title}</h1>
      </div>

      <div className="flex items-center gap-2 shrink-0">
        {showSync && <SyncStatusChip />}
        {rightAction}
      </div>
    </header>
  );
};

export default MobileHeader;
